// Utilities to mirror PHP helpers: video_src() and thumbnail_src()
// Builds CDN URLs based on the current host, handling staging and localhost similarly to PHP.

function resolveBaseDomain(): string {
  const aud = typeof window !== "undefined" ? window.location.host : "unknown";
  const host = aud.includes(":") ? aud.split(":")[0] : aud;
  let baseDomain = host;

  if (/^staging(?:-[^.]+)?\./i.test(host)) {
    const parts = host.split(".");
    parts.shift();
    baseDomain = parts.join(".");
  }

  if (baseDomain === "localhost" || baseDomain === "127.0.0.1") {
    baseDomain = "getmytestdomain.com";
  }

  return baseDomain;
}

export function videoSrc(videoId: string): string {
  const baseDomain = resolveBaseDomain();
  const cdnBase = `https://cdn.${baseDomain}`;

  const normalized = String(videoId || "").replace(/^\/+/, "");
  const hasExt = /\.mp4(?:\?.*)?$/i.test(normalized);
  const path = `/${hasExt ? normalized : `${normalized}.mp4`}`;

  return `${cdnBase}${path}`;
}

export function thumbnailSrc(videoId: string, ext: string = "webp"): string {
  const baseDomain = resolveBaseDomain();
  const cdnBase = `https://cdn.${baseDomain}`;
  const cleanExt = String(ext || "webp").replace(/^\./, "");
  const normalized = String(videoId || "").replace(/^\/+/, "");
  return `${cdnBase}/streamsMigration/thumbnails/${normalized}.${cleanExt}`;
}
